import React from 'react';
import en from '../../../international/translations/en';
import brandToString from '../../../utils/brandToString';

const PaymentWarningsBanner = ({ warningType }) => {
  const displayText = warningType === 'failedPayment' ?
    en.subscription.paymentWarnings.paymentFailure(brandToString()) :
    en.subscription.paymentWarnings.invalidZip(brandToString());
  return (
    <div className="payment__warnings__message">
      <a href="#payment-details">
        {displayText}
      </a>
    </div>
  );
};

export default PaymentWarningsBanner;
